// extracted by mini-css-extract-plugin
module.exports =  {"img":"_59fcf583bb--img--xrNvT","control":"_59fcf583bb--control--c8B_5","control-content":"_59fcf583bb--control-content--mv5Di","icon":"_59fcf583bb--icon--UBAv0"};